import React from "react";
import {FaFacebookF, FaGooglePlusG, FaInstagram, FaLinkedin, FaTwitter,} from "react-icons/fa";

const Footer = () => {
    return (
        <div
            className="bg-[#434a51] text-[#e1e2e3] text-[13px] w-full font-light min-h-[5vh] py-6 px-4 flex flex-col justify-center items-center max-w-[100%] mx-auto">
            <div className="flex space-x-2.5 mb-5 lg:hidden">
                <SocialMediaIconContainer>
                    <FaFacebookF/>
                </SocialMediaIconContainer>
                <SocialMediaIconContainer>
                    <FaTwitter/>
                </SocialMediaIconContainer>
                <SocialMediaIconContainer>
                    <FaGooglePlusG/>
                </SocialMediaIconContainer>
                <SocialMediaIconContainer>
                    <FaInstagram/>
                </SocialMediaIconContainer>
                <SocialMediaIconContainer>
                    <FaLinkedin/>
                </SocialMediaIconContainer>
            </div>
            <div className="AppInner lg:flex justify-between ">
                <div className="lg:flex lg:space-x-7 ">
                    <span>© 2022 Guaranty Trust Bank, Ghana. All Rights Reserved.</span>
                    <div className="w-full lg:w-auto flex justify-center flex-wrap space-x-2">
                        <a href="https://www.gtbghana.com/terms-and-conditions">Terms and Conditions</a>
                        <a href="https://www.gtbghana.com/privacy-policy">Privacy Policy</a>
                        <a href="https://www.gtbghana.com/sitemap">Sitemap</a>
                    </div>
                </div>

                <div className="hidden lg:flex space-x-2.5">
                    <SocialMediaIconContainer href="https://business.facebook.com/gtbankgh">
                        <FaFacebookF/>
                    </SocialMediaIconContainer>
                    <SocialMediaIconContainer href="https://twitter.com/GTBankGhana">
                        <FaTwitter/>
                    </SocialMediaIconContainer>
                    <SocialMediaIconContainer href="https://plus.google.com/u/0/+GTbankGhanaltd">
                        <FaGooglePlusG/>
                    </SocialMediaIconContainer>
                    <SocialMediaIconContainer href="https://www.instagram.com/gtbankgh">
                        <FaInstagram/>
                    </SocialMediaIconContainer>
                    <SocialMediaIconContainer href="https://www.linkedin.com/in/gtbankghana">
                        <FaLinkedin/>
                    </SocialMediaIconContainer>
                </div>
            </div>
        </div>
    );
};

export default Footer;

const SocialMediaIconContainer = ({children, href}) => {
    return (
        <a href={href}
           className="rounded rounded-full h-6 w-6 flex items-center justify-center text-sm text-[#434a51] bg-[#e1e2e3]">
            {children}
        </a>
    );
};
